export const globalStyle = {
  navHeight: 72,
  searchHeight: 65,
};
